import {
  getAllBrandOwner ,
  getCommonData
} from '@/api/common'

const state = {
  brands: [], // 品牌
  property: [], // 系统属性
  build: [] // 建筑业态
}

const actions = {
  // 获取全部品牌
  BASE_DATA_GET_BRANDS ({ commit }) {
    getAllBrandOwner().then(result => {
      if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('BASE_DATA_SET_BRANDS', result.data.data || [])
      }
    })
  },
  // 获取公共数据
  BASE_DATA_GET_COMMONDATA ({ commit }, id) {
    let params = {
      id: id
    }
    getCommonData(params).then(result => {
      if (result.status === 200 && result.data && result.data.code === 200 && result.data.data) {
        commit('BASE_DATA_SET_COMMON_DATA', { type: id, list: result.data.data })
      }
    })
  }
}

const getters = {
  BASE_DATA_FILTER_BRANDS_DATA (state) {
    let letterBrands = [{'letter': 'A', list: []}, {'letter': 'B', list: []}, {'letter': 'C', list: []}, {'letter': 'D', list: []}, {'letter': 'E', list: []}, {'letter': 'F', list: []}, {'letter': 'G', list: []}, {'letter': 'H', list: []}, {'letter': 'I', list: []}, {'letter': 'J', list: []}, {'letter': 'K', list: []}, {'letter': 'L', list: []}, {'letter': 'M', list: []}, {'letter': 'N', list: []}, {'letter': 'O', list: []}, {'letter': 'P', list: []}, {'letter': 'Q', list: []}, {'letter': 'R', list: []}, {'letter': 'S', list: []}, {'letter': 'T', list: []}, {'letter': 'U', list: []}, {'letter': 'V', list: []}, {'letter': 'W', list: []}, {'letter': 'X', list: []}, {'letter': 'Y', list: []}, {'letter': 'Z', list: []}]
    letterBrands.forEach(letterItem => {
      state.brands.forEach(item => {
        if (letterItem.letter === item.firstLetter) {
          letterItem.list.push(item)
        }
      })
    })
    return letterBrands
  }
}

const mutations = {
  // 设置品牌数据
  BASE_DATA_SET_BRANDS (state, data) {
    state.brands = data
  },
  // 设置基础数据
  BASE_DATA_SET_COMMON_DATA (state, data) {
    // 5一级系统属性
    if (data.type === 5) {
      state.property = data.list
    }
    // 6建筑业态
    if (data.type === 6) {
      state.build = data.list
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data.js